import { RootState } from './../store';
import { IUserInput, IAuthInfo } from './../../models/authentication';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthenticationState = {
    isAuthenticated: boolean;
    isAuthenticationLoading: boolean;
    refreshToken: string;
    accessToken: string;
    authInfo: IAuthInfo | undefined;
    userId: String | undefined;
    expiresIn: Number | undefined;
    approved: Boolean;
    adminAccountAlert: Boolean;
};
export const initialState: AuthenticationState = {
    isAuthenticated: false,
    isAuthenticationLoading: false,
    refreshToken: '',
    accessToken: '',
    authInfo: undefined,
    userId: '',
    expiresIn: 0,
    approved: true,
    adminAccountAlert: false,
};
// Action =====================================================
const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        /**
         * POST
         * Login
         */

        loginRequest(state, _action: PayloadAction<IUserInput>) {
            state.authInfo = undefined;
            state.isAuthenticated = false;
            state.isAuthenticationLoading = true;
            state.refreshToken = '';
        },
        loginSuccess(state, action: any) {
            // state.accessToken = action.payload;
            state.isAuthenticated = action.payload;
        },
        loginFailure(state, _action: PayloadAction<undefined>) {
            state.authInfo = undefined;
            state.isAuthenticated = false;
            state.isAuthenticationLoading = false;
            state.refreshToken = '';
        },
        setUserId: (state, action) => {
            state.userId = action.payload;
        },
        setExprired: (state, action) => {
            state.expiresIn = action.payload;
        },
        setTokenRefresh: (state, action) => {
            state.refreshToken = action.payload;
        },
        setApproved: (state, action) => {
            state.approved = action.payload;
        },
        setAdminAccountAlert: (state, action) => {
            state.adminAccountAlert = action.payload;
        },
        logout: (state) => {
            // reset store. Refer to `createResettableRootReducer` in `src/redux/reducers.ts`
        },
    },
});
export const authenticationActions = authenticationSlice.actions;
// Selector =====================================================
export const selectAccessToken = (state: RootState) => state.authentication.accessToken;
export const selectApproved = (state: RootState) => state.authentication.approved;
// Reducer=====================================================
const authenticationReducer = authenticationSlice.reducer;
export default authenticationReducer;
